// extracted by mini-css-extract-plugin
export default {"venueRating":"VenueRating--venueRating--6bc848"};